import axios from "axios";
import { BASE_URL } from "./axiosHandler";

export default axios.create({
	baseURL: "https://mallaranim.hamropalika.org",
});
